module.exports = __webpack_public_path__ + "img/HY1702-193.7fe74388.jpg";